export default {
  platformNames: {
    Wahool: 'Wahool', // 供应商
    Amazon: 'Amazon', // 商家端
  }
}
